module.exports = __webpack_public_path__ + "media/images/fnpcLogo-e81dafc3.jpeg";